/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import uiConf from "../../config/uiConf";

import Dialog from "../dialog/functional/Dialog";
import DialogHeader from "../dialog/functional/DialogHeader";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogContent from "../dialog/functional/DialogContent";
import DialogActionsOk from "../dialog/functional/DialogActionsOk";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import {debounce} from "lodash";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 0
    }
}));

function TkFilesDownloadDialog ( props ) {

    const { t } = useTranslation ();

    const classes = useStyles ();

    const [ , setInstance ] = useState ();
    const [ url, setUrl ] = useState ();
    const [ grid, setGrid ] = useState ();
    const [ extension, setExtension ] = useState ();

    const protocol_domain = process.env.NODE_ENV === "production" ? "" : "http://localhost:8080";

    const apiPath = "/PreViewPdf";

    const { id, moveable, resizable, fullWidth, maxWidth, onClose, onInitialized, $parent, view, onModifyViewUrl, pdfConf, dialogTitle, ...others } = props;

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        const filePath = grid.selectedItems[0].filePath;

                        const extension = filePath?.substring(filePath.lastIndexOf(".") + 1).toUpperCase();

                        setExtension ( extension );

                        if ( extension === "PDF" ) {

                            setUrl(protocol_domain + apiPath + filePath + pdfConf);

                        } else if ( [ "JPG", "JPEG", "PNG", "BMP", "GIF" ].includes ( extension ) ) {

                            setUrl(protocol_domain + filePath);

                        } else {

                            setUrl([]);

                        }

                    } else {

                        setUrl([]);

                    };

                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        const filePath = grid.selectedItems[0].filePath;

                        const extension = filePath?.substring(filePath.lastIndexOf(".") + 1).toUpperCase();

                        setExtension ( extension );

                        if ( extension === "PDF" ) {

                            setUrl(protocol_domain + apiPath + filePath + pdfConf);

                        } else if ( [ "JPG", "JPEG", "PNG", "BMP", "GIF" ].includes ( extension ) ) {

                            setUrl(protocol_domain + filePath);

                        } else {

                            setUrl([]);

                        }

                    } else {

                        setUrl([]);

                    };

                }), 10);
            }

        })()

    }, [grid, pdfConf])

    const onDialogInitialized = ( instance ) => {

        setInstance ( instance );
        
        if ( onInitialized ) {

            onInitialized ( instance );
            
        }

    };

    const onCloseDialog = () => {

        if ( onClose ) {
    
            onClose ();
            
        }
    
    };

    const onGridInitialized = ( grid ) => {

        grid.selectionMode = "Row";

        setGrid ( grid );

    }

    return (

        <Dialog
            id={id || "filesDownload"}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth={maxWidth ? maxWidth : uiConf.approvalStateDialogMaxWidth}
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            {
                uiConf.modalWithCloseButton
                ?
                    <DialogHeaderWithClose>
                        <DialogTitle>
                            { t ( dialogTitle ? `columnName.${dialogTitle}` : "columnName.filePath" ) }
                        </DialogTitle>
                    </DialogHeaderWithClose>
                :
                <DialogHeader>
                    <DialogTitle>
                        { t ( dialogTitle ? `columnName.${dialogTitle}` : "columnName.filePath" ) }
                    </DialogTitle>
                </DialogHeader>
            }

            <DialogContent className={classes.root} dividers style={{padding: "0px", height: "600px"}}>

                <ReflexContainer orientation="vertical">

                    <ReflexElement flex={0.5}>

                        <BasicCrudScreenType 
                            id={id}
                            headerTitle={t("term.fileList")}
                            view={view}
                            noCreate
                            noEdit
                            noDelete
                            noExcel
                            noSearch
                            noFilter
                            noPagination
                            onInitialized={onGridInitialized}
                            onModifyViewUrl={onModifyViewUrl}
                            embededInOtherScreenType
                        />

                    </ReflexElement>

                    <ReflexSplitter style={{border: "none",height: "1px",color:"lightgray"}} />

                    <ReflexElement flex={0.5}>

                        {
                            url && extension === "PDF"
                            ?
                            <embed src={url} style={{marginLeft: "auto", marginRight: "auto", height: "99%", width: "100%"}}/>
                            :
                            url && [ "JPG", "JPEG", "PNG", "BMP", "GIF" ].includes ( extension )
                            ?
                            <img alt={url} src={url} style={{marginLeft: "auto", marginRight: "auto", height: "99%", width: "100%"}}/>
                            :
                            <></>
                        }

                    </ReflexElement>

                </ReflexContainer>

            </DialogContent>

            <DialogActionsOk
                close
            />

        </Dialog>
        
    );

}

export default TkFilesDownloadDialog;

